module.exports = __webpack_public_path__ + "static/media/s_bar14.c856e873.svg";